import { createContext } from 'react'

interface BreakpointContext {
  width: number
  height: number
  provider: string
}
/**
 * @brief React context for managing the current breakpoint. To access breakpoint information within the BreakpointContext.Provider, use the useBreakpoint hook.
 *
 * @param N/A
 *
 * @returns A React context object with a value of type `BreakpointContext`.
 *
 * @usage
 * const breakpoint = useContext(BreakpointContext)
 *
 * if (breakpoint) {
 *   console.log(breakpoint.width)
 *   console.log(breakpoint.height)
 *   console.log(breakpoint.provider)
 * }
 */
export const BreakpointContext = createContext<BreakpointContext | null>(null)
